<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import store from '../../../store';
import i18n from '../../../i18n';
import TwCopyAndTranslateModal from '../../../components/TwCopyAndTranslateModal';

export default {
  name: 'SkiRentalSeasonPrices',
  components: { TwCopyAndTranslateModal },
  data() {
    return {
      showOldPeriodPrices: false,
      priceItemIndex: null,
      copyAndTranslateModalOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      levels: 'skirental/getLevels',
      skiPackages: 'skirental/getPackages',
      skiTypes: 'skirental/getSkiTypes',
      personCategories: 'skirental/getPersonCategoriesWithAllOption',
      possiblePriceCombinations: 'skirental/getPossiblePriceCombinations',
      possiblePriceCombinationsWithPrices: 'skirental/getPossibleCombinationsWithPrices',
    }),
    ...mapState({
      season: state => state.skirental.season,
      xmlProducts: state => state.twenty.xmlProducts[3].items,
      xmlProductsPickupPlaces: state => state.twenty.xmlProducts[6].items,
      periodDates: state => state.skirental.season.periodDates.items,
      prices: state => state.skirental.season.prices.items,
      pricesLoading: state => state.skirental.season.prices.itemsLoading,
      pricesError: state => state.skirental.season.prices.itemsError,
      pricesSaveLoading: state => state.skirental.season.prices.saveLoading,
      pricesSaveError: state => state.skirental.season.prices.saveError,
      personCategoriesLoading: state => state.skirental.season.personCategories.itemsLoading,
      personCategoriesError: state => state.skirental.season.personCategories.itemsError,
      selectedPersonCategoryIds: state =>
        state.skirental.season.priceCombinations.selectedPersonCategoryIds,
      selectedLevelIds: state => state.skirental.season.priceCombinations.selectedLevelIds,
      selectedSkiTypeIds: state => state.skirental.season.priceCombinations.selectedSkiTypeIds,
      selectedPackageIds: state => state.skirental.season.priceCombinations.selectedPackageIds,
      onlyShowSavedPrices: state => state.skirental.season.priceCombinations.onlyShowSavedPrices,
      onlyShowPricesMissingXmlChannelProducts: state => state.skirental.season.priceCombinations.onlyShowPricesMissingXmlChannelProducts,
      priceCombinationsLoading: state => state.skirental.season.priceCombinations.itemsLoading,
      priceCombinationsError: state => state.skirental.season.priceCombinations.itemsError,
      levelsLoading: state => state.skirental.levels.itemsLoading,
      levelsError: state => state.skirental.levels.itemsError,
      packagesSaveError: state => state.skirental.packages.saveError,
      packagesLoading: state => state.skirental.packages.itemsLoading,
      packagesError: state => state.skirental.packages.itemsError,
      skiTypesSaveError: state => state.skirental.skiTypes.saveError,
      skiTypesLoading: state => state.skirental.skiTypes.itemsLoading,
      skiTypesError: state => state.skirental.skiTypes.itemsError,
      selectedDomainId: state => state.ski.selectedDomainId,
      domains: state => state.twenty.domains.items,
    }),
    errorOccurred() {
      return this.pricesSaveError || this.pricesError;
    },
    filteredXmlProductsByXmlChannel() {
      if (this.season.xmlChannelId) {
        return this.xmlProducts.filter(xmlProduct => xmlProduct.xmlChannelId === this.season.xmlChannelId);
      }
      return [];
    },

    getCopyValues() {
      const values = [];

      this.possiblePriceCombinationsWithPrices.forEach(priceCombo => {
        values.push(
          {
            globalModelId: priceCombo.price.id,
            globalModelColumnName: 'ski_rental_season_price_id',
            selectKeyOverrides: [ 'domain_id', 'ski_rental_season_price_id' ],
            tableName: 'domain_ski_rental_season_price',
            sourceDomainId: null,
            selectedFromDomain: null,
            fromLanguageIsoOverride: null,
            sourceIsoOverride: null,
            disableSourceIsoOverride: true,
            toDomains: [],
            shouldTranslate: false,
            shouldCopySeo: false,
            fieldNamesAndValuesToCopyAndTranslate: [
              { name: priceCombo.price.name },
              { domain_id: null },
              { ski_rental_season_price_id: priceCombo.price.id },
            ],
            title: `Price: ${priceCombo.price.name}`,
          },
        );
      });
      return values;
    },
  },
  methods: {
    ...mapActions({
      loadLevels: 'skirental/levelsLoad',
      loadPackages: 'skirental/packagesLoad',
      loadSkiTypes: 'skirental/skiTypesLoad',
      loadPersonCategories: 'skirental/personCategoriesByIdLoad',
      loadPeriodDates: 'skirental/periodDatesByIdLoad',
      loadPossiblePriceCombinations: 'skirental/possiblePriceCombinationsBySeasonIdLoad',
      loadPricesWithDaysBySeasonId: 'skirental/pricesWithDaysBySeasonIdLoad',
      setPriceCombinationPersonCategory: 'skirental/setPriceCombinationPersonCategory',
      setPriceCombinationLevel: 'skirental/setPriceCombinationLevel',
      setPriceCombinationPackage: 'skirental/setPriceCombinationPackage',
      setPriceCombinationSkiType: 'skirental/setPriceCombinationSkiType',
      setPriceCombinationOnlyShowSavedPrices: 'skirental/setPriceCombinationOnlyShowSavedPrices',
      setPriceCombinationOnlyShowPricesMissingXmlChannelProducts: 'skirental/setPriceCombinationOnlyShowPricesMissingXmlChannelProducts',
      setPrice: 'skirental/setPrice',
      setPriceDay: 'skirental/setPriceDay',
      priceSave: 'skirental/priceSave',
      priceRemove: 'skirental/priceRemove',
      setFiltersClear: 'skirental/setFiltersClear',
    }),
    createOrUpdatePrice(priceCombination) {
      const item = this.season.prices.items.find(price => price.id === priceCombination.price.id && price.skiRentalSeasonPersonCategoryId === priceCombination.price.skiRentalSeasonPersonCategoryId);
      if (!item.xmlChannelProductIds) {
        item.xmlChannelProductIds = [];
      }
      this.priceSave(item);
    },
    removePriceWithDays(priceId) {
      // eslint-disable-next-line no-alert
      if (!priceId || confirm(i18n.t('ski.skiPrice.removeAreYouSure'))) {
        this.priceRemove({
          seasonId: this.season.id,
          priceId,
        });
      }
    },
    onPersonCategoryChange(personCategoryIds) {
      this.setPriceCombinationPersonCategory(personCategoryIds);
    },
    onSkiLevelChange(skiLevelIds) {
      this.setPriceCombinationLevel(skiLevelIds);
    },
    onSkiPackageChange(skiPackageIds) {
      this.setPriceCombinationPackage(skiPackageIds);
    },
    onSkiTypeChange(skiTypeIds) {
      this.setPriceCombinationSkiType(skiTypeIds);
    },
    onShowOnlySavedPricesChange(onlyShowSavedPrices) {
      this.setPriceCombinationOnlyShowSavedPrices(onlyShowSavedPrices);
    },
    onOnlyShowPricesMissingXmlChannelProducts(onlyShowPricesMissingXmlChannelProducts) {
      this.setPriceCombinationOnlyShowPricesMissingXmlChannelProducts(onlyShowPricesMissingXmlChannelProducts);
    },
    onPriceChange(params, price) {
      this.setPrice({
        params,
        price,
      });
      this.$forceUpdate();
    },
    onPriceDayChange(price, periodId, days, priceCombination) {
      this.setPriceDay({
        price,
        periodId,
        days,
        priceId: priceCombination.price.id,
        priceCombination,
      });
      this.$forceUpdate();
    },
    doRefresh() {
      this.loadLevels();
      this.loadPackages();
      this.loadSkiTypes();
      this.loadPersonCategories(this.season.id);
      this.loadPricesWithDaysBySeasonId(this.season.id);
      this.loadPossiblePriceCombinations(this.season.id);
      this.loadPeriodDates(this.season.id);
    },
    getCommissionOrContributionHeader() {
      const headerText = this.season.netOrGross === 'net'
        ? i18n.t('ski.skiPrice.dataHeaders.contribution')
        : i18n.t('ski.skiPrice.dataHeaders.commission');
      const ratioPercentage = this.season.netOrGross === 'net'
        ? this.season.contributionRatio
        : this.season.commissionRatio;

      return headerText.concat(': ').concat(ratioPercentage).concat('%');
    },
    scrollToLastPrice() {
      setTimeout(() => {
        const targetElement = this.$refs['ski-price-combination'][this.priceItemIndex];
        if (targetElement) {
          this.$vuetify.goTo(
            targetElement,
            {
              duration: 1500,
              offset: 0,
              easing: 'easeInOutCubic',
            },
          );

          this.priceItemIndex = null;
        }
      }, 3000);
    },
    formatDate(date) {
      return date ? this.$moment(date).format('DD-MM-YY') : '';
    },
  },
  watch: {
    pricesLoading(newValue) {
      if (!newValue && this.priceItemIndex) {
        this.scrollToLastPrice();
      }
    },
  },
  mounted() {
    if (!this.levels || !this.levels.length) {
      this.loadLevels();
    }
    if (!this.skiPackages || !this.skiPackages.length) {
      this.loadPackages();
    }
    if (!this.skiTypes || !this.skiTypes.length) {
      this.loadSkiTypes();
    }
    if (!this.periodDates || !this.periodDates.length) {
      this.loadPeriodDates(this.season.id);
    }
    if (this.season.id) {
      if (!this.priceCombinations || !this.priceCombinations.length) {
        this.loadPossiblePriceCombinations(this.season.id);
      }
      if (!this.personCategories || !this.personCategories.length) {
        this.loadPersonCategories(this.season.id);
      }
      if (!this.prices || !this.prices.length) {
        this.loadPricesWithDaysBySeasonId(this.season.id);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.seasonId) {
      store.dispatch('skirental/seasonWithRelationsBySeasonIdLoad', to.params.seasonId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>
<template>
  <v-container class="pa-0">
    <h2 class="pb-3 d-inline-block">
      {{ $t('skiRental.dataHeaders.prices') }}
    </h2>
    <v-btn
      :loading="pricesLoading || priceCombinationsLoading"
      icon
      @click="doRefresh()"
    >
      <v-icon>cached</v-icon>
    </v-btn>
    <v-btn
      v-if="possiblePriceCombinationsWithPrices.length"
      :loading="personCategoriesLoading"
      color="primary success"
      @click="copyAndTranslateModalOpen = !copyAndTranslateModalOpen"
    >
      Copy/translate
    </v-btn>
    <tw-copy-and-translate-modal
      v-if="copyAndTranslateModalOpen"
      :elements-to-handle="getCopyValues"
      :domains="domains"
    />
    <v-card
      v-if="personCategories.length"
      class="pa-3 mx-auto"
      outlined
    >
      <v-layout>
        <v-flex class="font-weight-bold" sm12 xs12>
          <h3>
            {{ getCommissionOrContributionHeader() }}
          </h3>
          <h3>
            {{ $t('ski.supplier-currency') }}:
            <template v-if="season.supplier">
              {{ season.supplier.currency }}
              ({{ season.supplier.name }})
            </template>
          </h3>
        </v-flex>
      </v-layout>
      <v-layout class="pt-3">
        <v-flex class="font-weight-bold" sm1 xs1>
          <h3>{{ $t('ski.skiPrice.filter') }}</h3>
        </v-flex>
        <v-flex sm3 xs3>
          <v-select
            :value="selectedPersonCategoryIds"
            :items="personCategories"
            :loading="personCategoriesLoading"
            :disabled="onlyShowSavedPrices"
            :deletable-chips="true"
            :label="'Person categories'"
            item-text="nameWithAges"
            item-value="id"
            hide-details
            chips
            multiple
            @change="onPersonCategoryChange($event)"
          />
        </v-flex>
        <v-flex sm2 xs2 offset-sm1>
          <v-select
            :value="selectedSkiTypeIds"
            :items="skiTypes"
            :loading="skiTypesLoading"
            :disabled="onlyShowSavedPrices"
            :deletable-chips="true"
            :label="'Ski types'"
            item-text="name"
            item-value="id"
            hide-details
            chips
            multiple
            @change="onSkiTypeChange($event)"
          />
        </v-flex>
        <v-flex sm3 xs2 offset-sm1>
          <v-select
            :value="selectedPackageIds"
            :items="skiPackages"
            :loading="packagesLoading"
            :disabled="onlyShowSavedPrices"
            :deletable-chips="true"
            :label="'Ski packages'"
            item-text="name"
            item-value="id"
            hide-details
            chips
            multiple
            @change="onSkiPackageChange($event)"
          />
        </v-flex>
        <v-flex sm2 xs2 offset-sm1>
          <v-select
            :value="selectedLevelIds"
            :items="levels"
            :loading="levelsLoading"
            :disabled="onlyShowSavedPrices"
            :deletable-chips="true"
            :label="'Levels'"
            item-text="name"
            item-value="id"
            hide-details
            chips
            multiple
            @change="onSkiLevelChange($event)"
          />
        </v-flex>
      </v-layout>
      <v-layout class="pt-2">
        <v-flex sm4 xs4 offset-sm1>
          <v-switch
            :disabled="prices.length === 0"
            :label="$t('ski.skiPrice.onlyShowSavedPrices')"
            :input-value="onlyShowSavedPrices"
            @change="onShowOnlySavedPricesChange($event)"
          />
          <v-switch
            :disabled="prices.length === 0"
            label="Show unmappped Xml Channel Products"
            :input-value="onlyShowPricesMissingXmlChannelProducts"
            @change="onOnlyShowPricesMissingXmlChannelProducts($event)"
          />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex
          v-if="!pricesLoading && !priceCombinationsLoading"
          class="font-weight-bold"
          sm12
          xs12
          offset-sm1
        >
          {{
            $t('ski.skiPrice.showingTotalPriceCombinations',
               { totalPrices: possiblePriceCombinationsWithPrices.length }
            )
          }}
          <template v-if="Object.keys(prices).length > 0">
            {{ $t('ski.skiPrice.pricesSavedOverall', { totalPrices: prices.length }) }}
          </template>
          <v-btn
            v-if="!pricesLoading && !priceCombinationsLoading"
            class="mb-2"
            color="warning"
            small
            outline
            @click="setFiltersClear"
          >
            {{ $t('ski.skiPriceSettings.clear-filters') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <span v-else>
      <v-btn
        v-if="!pricesLoading && !priceCombinationsLoading"
        :to="`/ski/rental/season/${season.id}/person-categories`"
        class="mb-2"
        color="warning"
        small
        outline
      >
        {{ $t('ski.skiPersonCategories.addMissingPersonCategories') }}
      </v-btn>
    </span>
    <v-alert
      :value="errorOccurred"
      color="error"
      icon="warning"
      outline
    >
      <span v-html="errorOccurred"/>
    </v-alert>
    <v-container
      v-for="(priceCombination, index) in possiblePriceCombinationsWithPrices"
      ref="ski-price-combination"
      :key="'ski-price-combination-' + index"
      :loading="pricesSaveLoading || priceCombinationsLoading"
      grid-list-md
      text-xs-center
      xs12
    >
      <div class="info-items">
        <v-layout xs12 row w-100>
          <v-flex class="xs3 font-weight-bold">
            <h2>
              {{
                $t('ski.skiPrice.personCategoryNameWithAge',
                   {
                     name: priceCombination.personCategory.name,
                     ageFrom: priceCombination.personCategory.ageFrom,
                     ageTo: priceCombination.personCategory.ageTo
                   }
                )
              }}
            </h2>
          </v-flex>
          <v-flex class="xs3 font-weight-bold">
            <h2>{{ priceCombination.skiType.name }}</h2>
          </v-flex>
          <v-flex class="xs3 font-weight-bold">
            <h2>{{ priceCombination.package.name }}</h2>
          </v-flex>
          <v-flex class="xs3 font-weight-bold">
            <h2>{{ priceCombination.level.name }}</h2>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs6>
            <v-text-field
              :value="priceCombination.price ? priceCombination.price.externalName : undefined"
              :label="$t('ski.skiPrice.supplierText')"
              :disabled="pricesSaveLoading || pricesLoading || priceCombinationsLoading"
              type="text"
              @change="onPriceChange({ externalName: $event }, priceCombination.price)"
            />
          </v-flex>
          <v-flex xs6>
            <v-text-field
              :value="priceCombination.price ? priceCombination.price.name : undefined"
              :disabled="pricesSaveLoading || pricesLoading || priceCombinationsLoading"
              label="Global Customer text"
              type="text"
              @change="onPriceChange({ name: $event }, priceCombination.price)"
            />
            <v-text-field
              v-if="selectedDomainId !== null"
              v-model="priceCombination.price.domains[selectedDomainId].name"
              :disabled="pricesSaveLoading || pricesLoading || priceCombinationsLoading"
              label="Domain Customer text"
              type="text"
            />
          </v-flex>
        </v-layout>
        <v-flex sm8 xs10>
          <v-autocomplete
            :value="priceCombination.price ? priceCombination.price.xmlChannelProductIds : []"
            :items="filteredXmlProductsByXmlChannel"
            label="XML Product"
            item-value="id"
            item-text="tbName"
            clearable
            multiple
            @input="onPriceChange({ xmlChannelProductIds: $event || null, changed: true}, priceCombination.price )"
          />
        </v-flex>
      </div>

      <v-layout
        v-for="(period, periodIndex) in periodDates"
        :key="'ski-price-combination-period-' + periodIndex"
        class="pb-2 row"
      >
        <v-flex style="white-space: nowrap" class="bp-2">
          {{ formatDate(period.arrivalFrom) }}
        </v-flex>
        <v-flex style="white-space: nowrap" class="bp-2">
          {{ formatDate(period.arrivalTo) }}
        </v-flex>
        <v-flex
          v-for="(priceDay, priceIndex) in priceCombination.days"
          :key="'ski-price-combination-day-' + index + '-' + priceIndex + '-' + periodIndex"
        >
          <v-text-field
            :value="priceCombination.price.days[period.id] &&
              priceCombination.price.days[period.id+''][priceDay+''] >= 0 ?
            priceCombination.price.days[period.id+''][priceDay+''] : ''"
            :label="$t('ski.skiPrice.numDays', { numDays: priceDay })"
            :disabled="pricesSaveLoading || pricesLoading || priceCombinationsLoading"
            type="Number"
            min="0"
            @input="onPriceDayChange($event, period.id, priceDay, priceCombination)"
          />
        </v-flex>
      </v-layout>

      <v-layout class="pb-2" row>
        <v-flex>
          <v-btn
            :disabled="
              !priceCombination.price.name
                || !priceCombination.price.externalName
                || pricesSaveLoading
                || pricesLoading
                || priceCombinationsLoading
            "
            class="mb-1"
            color="green"
            small
            outline
            @click="createOrUpdatePrice(priceCombination)"
          >
            SAVE
          </v-btn>
          <v-btn
            :disabled="!priceCombination.price.id
              || pricesSaveLoading
              || pricesLoading
              || priceCombinationsLoading
            "
            class="mb-1"
            color="error"
            small
            outline
            @click="removePriceWithDays(priceCombination.price.id)"
          >
            {{ $t('buttons.remove') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-divider/>
    </v-container>
  </v-container>
</template>

<style lang="scss">
.info-items {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/pages/ski/rental/SkiRentalSeasonPrices.vue